import { render, staticRenderFns } from "./ReportGraph.vue?vue&type=template&id=5936cd2c&"
import script from "./ReportGraph.vue?vue&type=script&lang=js&"
export * from "./ReportGraph.vue?vue&type=script&lang=js&"
import style0 from "./ReportGraph.vue?vue&type=style&index=0&id=5936cd2c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports